import {
  FirebaseNotificationType,
  IntegrationFormValues,
} from 'modules/mobileApps/context/integrationForm';
import { IntegrationOperationType } from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, OpenedModal } from 'modules/mobileApps/context/modal';
import { AppPlatform, Integration, IntegrationAuthType } from 'modules/mobileApps/types';

/** Returns whether a given `modalType` modal is open among `openedModals`. */
export const getIsModalOpen = (openedModals: OpenedModal[], modalType: ModalType) =>
  !!openedModals?.find((openedModal) => openedModal.modalType === modalType);

/** Returns a formatted integration object for create/update integration API request. */
export const formatIntegrationFieldsForSave = async (
  fields: IntegrationFormValues,
  integration: Integration,
  operationType: IntegrationOperationType,
  appPlatform: AppPlatform,
): Promise<Integration> => {
  /** androidUseOsNotifications should always be true for Firebase integrations on iOS */
  const convertNotificationType = (type: FirebaseNotificationType, platform: AppPlatform) => ({
    androidUseOsNotifications:
      type === FirebaseNotificationType.NOTIFICATION || platform === AppPlatform.IOS,
  });

  switch (fields.authType) {
    case IntegrationAuthType.FIREBASE_JSON: {
      const { authType, firebaseNotificationType, firebaseJsonFile } = fields;
      const { androidUseOsNotifications } = convertNotificationType(
        firebaseNotificationType,
        appPlatform,
      );
      const privateKey = (await firebaseJsonFile?.text()) || '';

      return {
        ...integration,
        /* androidUseOsNotifications/newUseOsNotificationsValue usage is pending BE update clarification,
         * but including both below to make the transition smoother and will clean this up after BE is finalized. */
        ...(operationType === IntegrationOperationType.UPDATE
          ? { newUseOsNotificationsValue: androidUseOsNotifications }
          : {}),
        androidUseOsNotifications,
        authType,
        privateKey,
        testPushSuccess: false,
      };
    }
    case IntegrationAuthType.P12: {
      const { authType, p12file, p12password } = fields;
      return { ...integration, authType, p12file, p12password, testPushSuccess: false };
    }
    case IntegrationAuthType.PEM: {
      const { authType, certificate, privateKey } = fields;
      return { ...integration, authType, certificate, privateKey, testPushSuccess: false };
    }
    case IntegrationAuthType.P8: {
      const { authType, p8File, keyID, teamID, bundleID } = fields;
      return { ...integration, authType, p8File, keyID, teamID, bundleID, testPushSuccess: false };
    }
    default:
      return { ...integration, ...fields };
  }
};
